import api from '@/services/api'

export default {
  getAll() {
    return api.get('/category-groups')
  },

  get(id) {
    return api.get(`/category-groups/${id}`)
  },

  save(data) {
    if (data._id) {
      return api.put(`/category-groups/${data._id}`, data)
    }
    return api.post('/category-groups', data)
  },

  remove(id) {
    return api.delete(`/category-groups/${id}`)
  },
}
